var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 2.25391C8.46062 2.25391 4.5 4.92578 4.5 9.25016C4.5 12.0002 6.04688 13.5627 6.98438 13.5627C7.37125 13.5627 7.59375 12.4845 7.59375 12.1802C7.59375 11.817 6.66812 11.0433 6.66812 9.53141C6.66812 6.39078 9.05875 4.16391 12.1525 4.16391C14.8125 4.16391 16.7812 5.67578 16.7812 8.45328C16.7812 10.5277 15.9494 14.4183 13.2537 14.4183C12.2813 14.4183 11.4488 13.7152 11.4488 12.7077C11.4488 11.2308 12.48 9.80141 12.48 8.27766C12.48 5.69203 8.81188 6.16078 8.81188 9.28578C8.81188 9.94203 8.89375 10.6683 9.18687 11.2664C8.6475 13.587 7.54625 17.0439 7.54625 19.4345C7.54625 20.1727 7.65187 20.8995 7.72187 21.6377C7.85437 21.7864 7.78813 21.7708 7.99125 21.6964C9.96 19.0008 9.89 18.4739 10.7806 14.9464C11.2613 15.8608 12.5031 16.3527 13.4875 16.3527C17.6356 16.3527 19.4994 12.3095 19.4994 8.66516C19.4994 4.78641 16.1475 2.25516 12.4681 2.25516L12.4688 2.25391Z",
    fill: "currentColor",
    fillOpacity: 0.96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.c3cf768b19728296f181cb39643139d8.svg";
export { ForwardRef as ReactComponent };